// ContactModal.js
import React from 'react';
import Image from "../../../assets";

const styles = `
  .contact-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .contact-modal {
    background: white;
    border-radius: 8px;
    width: 90%;              /* default: take most of screen on mobile */
    max-width: 400px;        /* never exceed this size on big screens */
    min-width: 280px;        /* prevent being too tiny */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    position: relative;
  }
  .contact-modal-header {
        display: flex;
        justify-content: center;
        padding: 7px 10px;
        margin-bottom: 7px;
        padding-top: 12px;
        text-align:left;
        padding-left: 20px
  }
  .contact-modal-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  .contact-modal-close {
    cursor: pointer;
    font-size: 20px;
    color: #666;
    border: none;
    background: none;
    position: relative;
    right: -5px;
  }
  .contact-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    text-decoration: none;
    color: #333;
    font-size: 14px;
    padding: 11px 14px;
  }
  .contact-option:hover {
    background: #f5f5f5;
  }
  .contact-option-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  .contact-option-arrow {
    color: #999;
  }
`;

function ForgotErrPop({ isVisible, onClose, msg }) {
    if (!isVisible) return null;

    return (
        <>
            <style>{styles}</style>
            <div className="contact-modal-overlay" onClick={onClose}>
                <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="contact-modal-header" style={{ marginTop: '0.5rem', fontSize: "20px", fontWeight: 'bold' }}>
                        <div>Information incorrect</div>

                    </div>

                    <div className="contact-modal-header" style={{ marginTop: "-8px", marginBottom: "0.5rem" }}>
                        {msg ? msg : 'The information you provided is incorrect. We’re unable to process your request. Please contact our customer care via WhatsApp at +65 6887 8777 to retrieve your information.'}

                    </div>

                    <div style={{ width: "90%", display: 'flex', flexDirection: "row", justifyContent: 'center', backgroundColor: "#FFBF00", margin: "auto", height: "46px", alignItems: "center", marginBottom: "1.5rem",cursor:"pointer" }} onClick={onClose}>Close</div>


                </div>
            </div>
        </>
    );
}

export default ForgotErrPop;